import React from 'react';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { Spinner } from '@isyc-react/design/bootstrap';
import { DocumentalValidationCode, ObjectTypeId } from '@isyc-react/types';
import { useDocumentalValidationRelatedReadQueryPromise } from 'common/api/query';
import { docGroupToCompleted, docGroupToCompletedAndPending, docGroupToPending } from './doc-group.utils';
import { DossierDocuments } from './dossier-documents.component';
export const DossierDocumentsContainer = props => {
    const { dossier } = props;
    const { user } = useAuthContext();
    // const personId = user?.person?.id ?? undefined
    // const actualParticipant = dossier.participants.find(p => p.id === personId)
    const getDocGroupValidation = useDocumentalValidationRelatedReadQueryPromise();
    const [loading, setLoading] = React.useState(true);
    const [docs, setDocs] = React.useState(null);
    const getGroupValidation = React.useCallback(() => {
        const promises = [];
        promises.push(getDocGroupValidation({ relatedId: dossier.id, relatedObjectTypeId: ObjectTypeId.DOSSIER }));
        dossier.participants.forEach(p => promises.push(getDocGroupValidation({ relatedId: p.id, relatedObjectTypeId: ObjectTypeId.PARTICIPANT })));
        Promise.all(promises).then(res => {
            var _a;
            const [resDossier, ...resParticipants] = res;
            const documentals = {
                completed: [],
                pending: [],
            };
            const resDossierFilter = resDossier.data.documentalValidation_read_byRelated.filter(d => {
                if (d.validation === DocumentalValidationCode.ANY) {
                    return d.pendingDocumentRequestIdList.length > 0;
                }
                else {
                    return d.documentalValidationLines.some(v => v.pendingDocumentRequestIdList.length > 0);
                }
            });
            const item = docGroupToCompletedAndPending(resDossierFilter, dossier.id, ObjectTypeId.DOSSIER, dossier.name);
            // documentals.completed.push(...item.completed)
            // documentals.pending.push(...item.pending)
            const dossierCompleted = docGroupToCompleted(resDossierFilter, dossier.id, ObjectTypeId.DOSSIER, dossier.name);
            const dossierPending = docGroupToPending(resDossierFilter, dossier.id, ObjectTypeId.DOSSIER, dossier.name);
            documentals.completed.push(...filterCompletedByCreatedBy(dossierCompleted, (_a = user === null || user === void 0 ? void 0 : user.username) !== null && _a !== void 0 ? _a : ''));
            documentals.pending.push(...dossierPending);
            dossier.participants.forEach((p, i) => {
                var _a;
                const resParticipantFilter = resParticipants[i].data.documentalValidation_read_byRelated.filter(d => {
                    if (d.validation === DocumentalValidationCode.ANY) {
                        return d.pendingDocumentRequestIdList.length > 0;
                    }
                    else {
                        return d.documentalValidationLines.some(l => l.pendingDocumentRequestIdList.length > 0);
                    }
                });
                const participantCompleted = docGroupToCompleted(resParticipantFilter, p.id, ObjectTypeId.PARTICIPANT, p.name);
                const participantPending = docGroupToPending(resParticipantFilter, p.id, ObjectTypeId.PARTICIPANT, p.name);
                documentals.completed.push(...filterCompletedByCreatedBy(participantCompleted, (_a = user === null || user === void 0 ? void 0 : user.username) !== null && _a !== void 0 ? _a : ''));
                documentals.pending.push(...participantPending);
                // const item = docGroupToCompletedAndPending(resParticipantFilter, p.id, ObjectTypeId.PARTICIPANT, p.name)
                // documentals.completed.push(...item.completed)
                // documentals.pending.push(...item.pending)
            });
            console.log('doc', documentals);
            setDocs(documentals);
            setLoading(false);
        });
    }, [dossier, user]);
    React.useEffect(() => {
        setLoading(true);
        getGroupValidation();
    }, [dossier]);
    //documentalGroup -> documentalValidationLines -> pendingDocumentRequestIdList
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, docs && dossier && !loading ? (React.createElement(React.Fragment, null,
            React.createElement(DossierDocuments, { docs: docs, businessUnitId: dossier.businessUnitId, onUpload: () => {
                    getGroupValidation();
                } }))) : (React.createElement("div", { className: 'd-flex justify-content-center align-items-center mb-4', style: { height: '500px' } },
            React.createElement(Spinner, { animation: 'border' }))))));
};
const filterCompletedByCreatedBy = (completed, createdBy) => {
    return completed
        .map(c => {
        const requests = c.requests
            .map(r => (Object.assign(Object.assign({}, r), { documentsEdm: r.documentsEdm.filter(d => d.createdBy === createdBy) })))
            .filter(r => r.documentsEdm.length > 0);
        return Object.assign(Object.assign({}, c), { requests });
    })
        .filter(c => c.requests.length > 0);
};
